module.exports = __webpack_public_path__ + "img/featureicon3.1eed4f91.svg";